import { createSelector } from 'reselect';

const onlineUsersSelector = state => state.onlineUsers;

export default createSelector(onlineUsersSelector, onlineUsers => ({onlineUsers}) );


// WEBPACK FOOTER //
// ./src/selectors/onlineUsersSelector.js